import clsx from "clsx";
import { ReactNode } from "react";

interface FieldRowProps {
  dataTestid?: string;
  className?: string;
  label: ReactNode;
  icon?: ReactNode;
  value?: ReactNode;
  disabled?: boolean;
}

export const FieldRow = ({
  dataTestid,
  className,
  label,
  icon,
  value,
  disabled = false,
}: FieldRowProps) => {
  const isEmpty = value === undefined || value === null || value === "";
  const textColor = disabled
    ? "text-foreground-tertiary"
    : "text-foreground-primary";

  return (
    <div
      data-testid={dataTestid}
      className={clsx(
        "flex min-h-14 min-w-0 items-center justify-between gap-3 rounded bg-surface-tertiary px-5",
        disabled && "bg-surface-quaternary",
        className,
      )}
    >
      {isEmpty ? (
        // Empty state: only the label, at value size, vertically centered
        <span
          className={clsx(
            "truncate text-base font-semibold leading-md",
            textColor,
          )}
        >
          {label}
        </span>
      ) : (
        <div className="flex min-w-0 flex-col">
          <span className={clsx("text-xs font-semibold leading-md", textColor)}>
            {label}
          </span>
          <span
            className={clsx(
              "truncate text-base font-semibold leading-md",
              textColor,
            )}
            title={
              typeof value === "string" || typeof value === "number"
                ? String(value)
                : undefined
            }
          >
            {value}
          </span>
        </div>
      )}
      {icon}
    </div>
  );
};
